<template>
  <a-card class="m-t-10" :bordered='false'>
    <a-button size='small' @click="()=>{$router.go(-1)}">
      <LeftOutlined />返回 </a-button>
    <span class="ml15 card_title">{{$route.query.type == 'add' ? '添加':'编辑'}}任务</span>
  </a-card>
  <a-card :bordered="false">
    <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item label="任务名称" name='name'>
        <a-input v-model:value="form.name" :maxlength='12' placeholder='请输入任务名称' style="width:200px" />（限12个字内）
      </a-form-item>
      <a-form-item label="任务描述" name='describe'>
        <a-input v-model:value="form.describe" :maxlength='12' placeholder='请输入任务描述'  style="width:200px"/>（限12个字内）
      </a-form-item>
      <a-form-item label="任务图片" name='image'>
        <div class="width-104 height-104 s_over">
          <material :groupType='1' :image="form.image" :max="1"  v-on:handlechoose="(data)=>{form.image=data}" v-on:handledel="form.image=''" />
        </div>
      </a-form-item>
      <a-form-item label="任务类型" name='task_type' help='同一会员卡不能多次设置相同任务类型'>
        <a-select v-model:value="form.task_type" placeholder='请选择类型' @change='typeChange' :disabled="$route.query.type == 'edit'" style="width:200px">
          <a-select-option v-for='item in typeList' :key='item.task_type' :value="item.task_type">{{item.name}}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="奖励频次" name='reward_num' v-if='form.task_type'>
        <a-select v-model:value="form.reward_num" placeholder='请选择类型' :disabled="$route.query.type == 'edit'">
          <a-select-option :value="1">仅一次</a-select-option>
          <a-select-option :value="2" :disabled='form.task_type == 5'>一天一次</a-select-option>
          <a-select-option :value="3" :disabled='form.task_type == 5'>一月一次</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="任务每次奖励" name='reward' v-if='form.task_type'>
        <a-input-number style='width: 92%;' v-model:value="form.reward" :min='1' :precision='0'  placeholder='请输入任务每次奖励' :disabled="$route.query.type == 'edit'"/>
        <span class="p-l-10">积分</span>
      </a-form-item>
      <a-form-item label="适用会员等级" name='vip_type' v-if='form.task_type'>
        <a-radio-group v-model:value="form.vip_type" :disabled="$route.query.type == 'edit'">
          <a-radio :value="1" v-if="!userTaskTypeList.length">全部会员等级</a-radio>
          <a-radio :value="2">指定等级会员</a-radio>
        </a-radio-group>
        <div v-if='form.vip_type == 2'>
          <a-button type="primary" @click='showUser = true' :disabled="$route.query.type == 'edit'">添加会员卡</a-button>
        </div>
        <a-table class="m-t-15" :pagination='false' :loading='listLoading' bordered rowKey='vip_id' :columns='columns' :data-source='userList' v-if='userList.length'>
          <template v-slot:action="{ index }">
            <a-button type="link" @click='delUser(index)' :disabled="$route.query.type == 'edit'">删除</a-button>
          </template>
        </a-table>
      </a-form-item>
      <a-form-item label="任务状态" name='status'>
        <a-radio-group v-model:value="form.status">
          <a-radio :value="1">启用</a-radio>
          <a-radio :value="0">禁用</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 4,offset:4}" >
        <a-button type="primary" @click="onSubmit">确定</a-button>
      </a-form-item>
    </a-form>
  </a-card>
  <!-- 选择会员 -->
  <a-modal  :keyboard="false" title="选择会员卡" centered v-model:visible="showUser" :footer="null" :width="1200" destroyOnClose>
    <selectUser v-on:select="userSelect" :selectList='userList' :disabledList='userTaskTypeList' :checkout='true' />
  </a-modal>
</template>
<script>
  import { LeftOutlined } from "@ant-design/icons-vue";
  import { message,Modal } from 'ant-design-vue';
  import { inject, reactive, ref, toRefs, onMounted } from "vue";
  import { getIntegralEdit,getIntegralAdd,getIntegralMore,getIntegralList,getTaskCard} from '@/api/assets'
  import { iscode } from '@/utils/app';
  import selectUser from './components/index.vue'
  let defForm = {
    name:'',
    describe:'',
    image:'',
    task_type:null,
    reward_num:2,
    reward:'',
    vip_type:1,
    vip_id:[],
    status:1
  }
  export default {
    name: "",
    components: {selectUser ,LeftOutlined},
    setup(props, { emit }) {
      let vip_type = async () => {
        if (form.value.vip_type == 2 && !state.userList.length) {
          return Promise.reject('请选择会员等级');
        } else {
          return Promise.resolve();
        }
      };
      const form = ref({ ...defForm });
      const ruleForm = ref();
      const state = reactive({
        labelCol: { span: 4 },
        wrapperCol: { span:8 },
        showUser:false,
        selectList:[],
        typeList:[],
        userTaskTypeList:[],
        rules: {
          name: [{ required: true, message: "请输入任务名称" }],
          describe: [{ required: true, message: "请输入任务描述" }],
          image: [{ required: true, message: "请选择任务图片" }],
          task_type: [{ required: true, message: "请选择任务类型" }],
          reward_num: [{ required: true, message: "请选择奖励频次" }],
          reward: [{ required: true, message: "请输入任务奖励" }],
          vip_type:[{ required: true, validator: vip_type }]
        },
        userList:[],
        columns: [
          {
            title: "ID",
            dataIndex: "vip_id",
            key: "vip_id",
          },
          {
            title: "名称",
            dataIndex: "vip_name",
            key: "vip_name",
          },
          {
            title: "成长值",
            dataIndex: "vip_exp",
            key: "vip_exp"
          },
          {
            title: "操作",
            key: "action",
            width: 120,
            slots: { customRender: "action" },
          }
        ]
      });
      const _lodash = inject("_lodash")
      const $route = inject('$route')
      const $router = inject('$router')
      // 获取任务类型
      const getType = async() =>{
        let res = await getIntegralList({brand_id:0}).then(res => res.data);
        if (iscode(res)) {
          state.typeList = res.data
        }else{
          message.error(res.msg);
        }
      }
      // 获取任务详情
      const getMore = async() =>{
        let res = await getIntegralMore({id:$route.query.id}).then(res => res.data);
        if (iscode(res)) {
          form.value = res.data
          state.userList = res.data.vip_data
        }else{
          message.error(res.msg);
        }
      }
      // 会员添加
      const userSelect = (e) =>{
        state.userList = e
        state.showUser = false
      }
      // 会员删除
      const delUser = (index) =>{
        state.userList.splice(index,1)
      }
      // 查询类型
      const getTaskCards=async (task_type)=>{
        console.log(task_type)
          let result=await getTaskCard({task_type}).then(res=>res.data)
          if(iscode(result)){
            state.userTaskTypeList=result.data
            if(state.userTaskTypeList.length){
                form.value.vip_type=2
            }
          }
      }

      // 选择任务类型
      const typeChange = (e) =>{
        if(e == 5){
          form.value.reward_num = 1
        }
        state.userList = []
        getTaskCards(e)
      }
      // 添加/编辑任务
      const onSubmit = async() =>{
        ruleForm.value.validate().then(async () => {
          Modal.confirm({
            title: form.value.id?'确认修改会员任务？':'确认生成会员任务？',
            content: form.value.id?'':'保存后部分数据将无法进行修改', 
            centered: true,
            onOk: async () => {
              let res
              form.value.vip_id = _lodash.map(state.userList, 'vip_id')
              if(form.value.id){
                res = await getIntegralEdit(form.value).then((res) => res.data);
              }else{
                res = await getIntegralAdd(form.value).then((res) => res.data);
              }
              if (iscode(res)) {
                message.success(res.msg);
                setTimeout(() => {
                  $router.go(-1)
                }, 2000);
              }else{
                message.error(res.msg);
              }
            }
          })
        }).catch((error) => {
          message.error("请完善表单！");
        });
      }
      
      onMounted(() => {
        if($route.query.id){
          getMore()
        }
        getType()
      })
      return {
        ...toRefs(state),
        form,
        ruleForm,
        onSubmit,
        userSelect,
        delUser,
        typeChange,
        getTaskCards
      };
    },
  };
</script>
